import { isAnyObject } from "@-/com.npmjs.is-what";

import type { SoftDeletableTable } from "@-/dev.improve.haniverse.lib.database";

export type { SoftDeletableTable } from "@-/dev.improve.haniverse.lib.database";

export function isSoftDeletableTable(table: unknown): table is SoftDeletableTable {
  return isAnyObject(table) && "deletedAt" in table;
}
